import { render, staticRenderFns } from "./DeleteDeviceCategory.vue?vue&type=template&id=15104ffc"
import script from "./DeleteDeviceCategory.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports